export const SUPPORT_BULK_UPDATE_FIELDS = [
  {
    key: "DOB",
    label: "Date of Birth",
    sampleHeader: "DateOfBirth",
    sampleValue: "01-01-2010",
    type: "date",
    excelHeaders: ["DOB", "DATEOFBIRTH"],
  },
  {
    key: "firstAdmissionDate",
    label: "First Admission Date",
    sampleHeader: "FirstAdmissionDate",
    sampleValue: "01-04-2024",
    type: "date",
    excelHeaders: ["FIRSTADMISSIONDATE"],
  },
  {
    key: "registrationNumber",
    label: "Registration Number",
    sampleHeader: "RegistrationNumber",
    sampleValue: "REG001",
    type: "string",
    excelHeaders: ["REGISTRATIONNUMBER"],
  },
  {
    key: "srNumber",
    label: "SR Number",
    sampleHeader: "SrNumber",
    sampleValue: "SR001",
    type: "string",
    excelHeaders: ["SRNUMBER"],
  },
  {
    key: "penNumber_center",
    label: "PEN Number",
    sampleHeader: "PenNumber",
    sampleValue: "PEN123456",
    type: "string",
    excelHeaders: ["PENNUMBER", "PENNUMBERCENTER"],
  },
  {
    key: "AADHAR",
    label: "Aadhar Number",
    sampleHeader: "AadharNumber",
    sampleValue: "123456789012",
    type: "aadhar",
    excelHeaders: ["AADHARNUMBER", "AADHAR"],
  },
  {
    key: "mobileNumber",
    label: "Mobile Number",
    sampleHeader: "MobileNumber",
    sampleValue: "9876543210",
    type: "mobile",
    excelHeaders: ["MOBILENUMBER", "MOBILE"],
  },
  {
    key: "admissionNumber",
    label: "New Admission Number",
    sampleHeader: "NewAdmissionNumber",
    sampleValue: "101",
    type: "number",
    excelHeaders: ["NEWADMISSIONNUMBER"],
  },
];

export const IDENTIFIER_SAMPLE_HEADERS = ["AdmissionNumber"];

export const IDENTIFIER_SAMPLE_ROW = {
  AdmissionNumber: "1001",
};

export const SUPPORT_ACCESS_STORAGE_KEY = "supportBulkStudentUpdateAccess";
export const SUPPORT_ACCESS_PIN_STORAGE_KEY = "supportBulkStudentUpdatePin";
